import * as React from "react"
import { Alert, AlertVariant } from "@walmart-web/livingdesign-components"
import { useIntl } from "react-intl"
import { Close } from "@walmart-web/livingdesign-icons"
import "./index.scss"

export interface Message {
	type: AlertVariant | undefined
	id: string
	millisecondDuration?: number
	errorMessage?: string
	values?: any
}

interface MessagePros {
	message: Message
	setMessage: any
}

const AlertMessage: React.FC<MessagePros> = ({
	message,
	setMessage,
}): JSX.Element | null => {
	const intl = useIntl()
	const [isVisible, setVisible] = React.useState(true)

	const hide = () => {
		setVisible(false)
		setMessage(null)
	}

	React.useEffect(() => {
		let timeout: NodeJS.Timeout
		if (message.millisecondDuration) {
			timeout = setTimeout(hide, message.millisecondDuration)
		}

		return () => {
			setVisible(true)
			clearTimeout(timeout)
		}
	}, [message])

	if (!isVisible) return null

	return (
		<Alert
			variant={message.type}
			UNSAFE_className="alert-message"
			actionButtonProps={
				message.type === "error"
					? {
							children: <Close className="icon-close" />,
							onClick: () => {
								setVisible(false)
							},
					  }
					: undefined
			}
		>
			{intl.formatMessage(
				{
					id: message.id,
				},
				{
					...message.values,
					b: (str) => <b>{str}</b>,
				}
			)}
		</Alert>
	)
}

export default AlertMessage
